import PageHeading from "../../../components/common/PageHeading";
import RightBar from "../../../components/common/RightBar";
import RightBarMethod from "../../../components/common/RightBar/RightBarMethod";
import { getDocs, collection, doc, query, where } from "firebase/firestore";
import { useAuthState } from "react-firebase-hooks/auth";
import { auth, db } from "../../../firebase";
import propertyImage from "../../../assets/images/houseImg.svg";

import {
  Button,
  Form,
  Col,
  Row,
  InputNumber,
  Space,
  DatePicker,
  Dropdown,
  Select,
  Input,
  Checkbox,
  Spin,
} from "antd";
import { SlOptions } from "react-icons/sl";
import { FaDollarSign } from "react-icons/fa";
import { BsInfoCircleFill } from "react-icons/bs";

import {
  vacncsproperties,
  vacncsbedrooms,
  vacncssortby,
} from "../../../data/vacancies";

import "./Vacancies.css";
import FilterContainer from "../../../components/common/FilterContainer";
import { propertyCardData } from "../../../data/guestcards";
import ConfirmationBox from "../../../components/common/ConfirmationBox";
import { useState } from "react";
import TextArea from "antd/es/input/TextArea";
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "react-hot-toast";
import { useSelector } from "react-redux";
import { SelectUser } from "../../../store/usersSlice";

const VacanciesRightBar = [
  RightBarMethod("Tasks", "t1", <i className="fa-solid fa-star"></i>, [
    RightBarMethod(
      "Bulk Post Vacancies",
      "1",
      "",
      "",
      "/leasing/vacancies/bulk-post-vacancies"
    ),
    RightBarMethod(
      "Create Vacancies List",
      "2",
      "",
      "",
      "/leasing/vacancies/create-vacancies"
    ),
    RightBarMethod(
      "New Rental Application",
      "3",
      "",
      "",
      "/leasing/rental-applications/NewRentalApplications"
    ),
    RightBarMethod(
      "New Guest Card",
      "4",
      "",
      "",
      "/leasing/guest-cards/new-guest-card"
    ),
    RightBarMethod(
      "Lease Templates",
      "5",
      "",
      "",
      "/leasing/leases/lease-templates"
    ),
  ]),

  RightBarMethod(
    " REPORTS",
    "t2",
    <i className="fa-solid fa-chart-column"></i>,
    [
      RightBarMethod("Unit Vacancy Detail", "6", "", "", "/"),
      RightBarMethod("Rental Application", "7", "", "", "/"),
      RightBarMethod("Guest Card Interest", "8", "", "", "/"),
      RightBarMethod("Owner Leasing", "9", "", "", "/"),
      RightBarMethod("Premium Leads Billing Detail", "10", "", "", "/"),
    ]
  ),

  RightBarMethod(
    " HELP TOPICS",
    "t3",
    <i className="fa-solid fa-circle-question"></i>,
    [
      RightBarMethod("Post & Unpost Vacancies", "11", "", "", "/"),
      RightBarMethod("Marketing Campaigns", "12", "", "", "/"),
      RightBarMethod("Premium Leads", "13", "", "", "/"),
    ]
  ),
];

const items = [
  {
    label: "Download Marketing Flyer",
    key: "item1",
  },
  {
    label: "Post Vacancy Manually",
    key: "item2",
  },
  {
    label: "Remove from Vacancies List",
    key: "item3",
  },
];

function Vacancies() {
  const [websiteConfirmationBoxOpen, setWebsiteConfirmationBoxOpen] =
    useState(false);
  const [internetConfirmationBoxOpen, setInternetConfirmationBoxOpen] =
    useState(false);
  const [premiumConfirmationBoxOpen, setPremiumConfirmationBoxOpen] =
    useState(false);
  const [checked, setChecked] = useState(false);
  const [disabled, setDisabled] = useState(true);
  const [id, setId] = useState(0);

  // ########### Firebase Code...##########
  const [getProperties, setProperties] = useState([]);
  const [vacanciesData, setVacanciesData] = useState([]);
  const [companyName, setCompanyName] = useState("");
  const [user, loading] = useAuthState(auth);
  const [isLoading, setIsLoading] = useState(true);

  const [isCompanyNameFetched, setIsCompanyNameFetched] = useState(false);
  const fetchCompanyName = async () => {
    try {
      const usersRef = collection(db, "allUsers");
      const userData = query(usersRef, where("uid", "==", user?.uid));
      const querySnapshot = await getDocs(userData);
      querySnapshot.forEach((doc) => {
        const res = doc.data();
        setCompanyName(res.companyName);
      });
      setIsCompanyNameFetched(true);
    } catch (error) {
      console.log("Error getting company name: ", error);
    }
  };
  useEffect(() => {
    fetchCompanyName();
  }, [user, loading]);

  const fetchProperties = async () => {
    setIsLoading(true);
    const companiesRef = collection(db, "companies");
    const companyDocRef = doc(companiesRef, companyName);
    const propertiesRef = collection(companyDocRef, "properties");
    try {
      const querySnapshot = await getDocs(propertiesRef);
      const propertiesData = querySnapshot.docs.map((doc) => ({
        ...doc.data(),
        id: doc.id,
      }));

      setProperties(propertiesData);
      setVacanciesData(propertiesData);
      setIsLoading(false);
    } catch (error) {
      console.error("Error fetching properties:", error);
    }
  };

  const onchangValue = () => {
    setVacanciesData(getProperties);
  };
  const searchByPropertyName = (values) => {
    const results = vacanciesData?.filter((post) => {
      if (
        values.searchByPropertyName &&
        values.searchByPropertyName.trim() !== ""
      ) {
        return (
          post?.propertyNameAddress.propertyName ===
          values.searchByPropertyName.trim()
        );
      }

      const rent = parseInt(post?.rentalInformation.marketRent);
      const availableOn = post?.marketingInformation?.availableOn;

      const isCatsAllowed = post?.amenities.catsAllowed;
      const isDogsAllowed = post?.amenities.dogsAllowed;
      const numberOfBedrooms = post?.rentalInformation.bedrooms;
      if (isCatsAllowed === values.isCatsAllowed) {
        return post;
      }

      if (isDogsAllowed.includes(values.isDogsAllowed)) {
        return post;
      }

      if (numberOfBedrooms.includes(values.bedrooms)) {
        return post;
      }
      const minRent = parseInt(values.minRent);
      const maxRent = parseInt(values.maxRent);
      if (minRent !== "" && maxRent !== "") {
        return rent >= minRent && rent <= maxRent;
      }

      if (minRent === "" || maxRent === "") {
        return rent >= minRent || rent <= maxRent;
      }

      const startDate = values["startDate"]
        ? values["startDate"].format("YYYY-MM-DD")
        : null;
      const endDate = values["startDate"]
        ? values["startDate"].format("YYYY-MM-DD")
        : null;
      // console.log(startDate);
      if (!startDate === undefined && !endDate === undefined) {
        return availableOn >= startDate && availableOn <= endDate;
      } else {
        return availableOn >= startDate || availableOn <= endDate;
      }
    });

    setVacanciesData(results);
  };

  const onFinish = (values) => {
    console.log("Success:", values);
    searchByPropertyName(values);
  };

  const onFinishFailed = (errorInfo) => {
    console.log("Failed:", errorInfo);
  };

  useEffect(() => {
    if (!isCompanyNameFetched) return;
    fetchProperties();
  }, [companyName, isCompanyNameFetched]);

  const navigate = useNavigate();

  const onChange = (e) => {
    setChecked(e.target.checked);
  };

  useEffect(() => {
    if (checked) {
      setDisabled(false);
    } else {
      setDisabled(true);
    }
  }, [checked]);

  const onClick = ({ key }) => {
    if (key === "2") {
      toast.success("key 2");
      navigate(`/property-tabs/${id}`);
    }
  };

  const propSearch = getProperties.map((properties) => ({
    value: `${properties.propertyNameAddress.propertyName} `,
    label: `${properties.propertyNameAddress.propertyName}`,
  }));

  const userInfo = useSelector(SelectUser);

  return (
    <>
      {isLoading ? (
        <div className="spin-container">
          <Spin tip="Loading..." />
        </div>
      ) : (
        <>
          <div className="vacancies">
            <PageHeading heading="Vacancies" />
            <Row>
              <Col span={24}>
                <FilterContainer heading="Filter your vacancies with the options below:">
                  <Form
                    name="basic"
                    labelCol={{
                      span: 6,
                    }}
                    wrapperCol={{
                      span: 16,
                    }}
                    autoComplete="off"
                    colon={false}
                    onFinish={onFinish}
                    onFinishFailed={onFinishFailed}
                    initialValues={{
                      isCatsAllowed: "No",
                      isDogsAllowed: "None",
                    }}
                  >
                    <Row>
                      <Col span={24}>
                        <Form.Item
                          label="Properties"
                          name={"searchByPropertyName"}
                        >
                          <Select
                            showSearch
                            allowClear
                            placeholder="Search by property, group, owner, or portfolio"
                            optionFilterProp="children"
                            filterOption={(input, option) =>
                              (option?.label ?? "")
                                .toLowerCase()
                                .includes(input.toLowerCase())
                            }
                            style={{
                              width: "100%",
                            }}
                            options={propSearch}
                            onChange={onchangValue}
                          />
                        </Form.Item>
                      </Col>
                      <Col span={24}>
                        <Form.Item label="Bedrooms" name={"bedrooms"}>
                          <Select
                            showSearch
                            placeholder="Number of bedrooms"
                            optionFilterProp="children"
                            filterOption={(input, option) =>
                              (option?.label ?? "")
                                .toLowerCase()
                                .includes(input.toLowerCase())
                            }
                            style={{
                              width: "100%",
                            }}
                            options={vacncsbedrooms}
                          />
                        </Form.Item>
                      </Col>

                      <Col offset={4} span={17}>
                        <Row justify="space-between" align="middle">
                          <Form.Item
                            label="Rent"
                            name={"minRent"}
                            style={{ marginLeft: "17px" }}
                          >
                            <Col>
                              <Space>
                                <InputNumber
                                  addonBefore={<FaDollarSign size={12} />}
                                  placeholder="Minimum"
                                  onChange={onchangValue}
                                />
                              </Space>
                            </Col>
                          </Form.Item>
                          <Col>
                            <span>To</span>
                          </Col>
                          <Form.Item name={"maxRent"}>
                            <Col>
                              <Space>
                                <InputNumber
                                  addonBefore={<FaDollarSign size={12} />}
                                  placeholder="Maximum"
                                  onChange={onchangValue}
                                />
                              </Space>
                            </Col>
                          </Form.Item>
                        </Row>
                      </Col>
                      <Col offset={4} span={18}>
                        <Row justify="space-between" align="middle">
                          <Col>
                            <Space direction="vertical">
                              <Form.Item
                                label="Available"
                                name={"startDate"}
                                style={{ marginLeft: "8px" }}
                              >
                                <DatePicker onChange={onchangValue} />
                              </Form.Item>
                            </Space>
                          </Col>
                          <Col>
                            <span>To</span>
                          </Col>
                          <Col>
                            <Space direction="vertical">
                              <Form.Item label="" name={"endDate"}>
                                <DatePicker onChange={onchangValue} />
                              </Form.Item>
                            </Space>
                          </Col>
                        </Row>
                      </Col>
                      <Col span={24}>
                        <Form.Item label="Cats Allowed" name={"isCatsAllowed"}>
                          <Select
                            style={{
                              width: "100%",
                            }}
                            options={[
                              {
                                value: "Yes",
                                label: "Yes",
                              },
                              {
                                value: "No",
                                label: "No",
                              },
                            ]}
                            onChange={onchangValue}
                          />
                        </Form.Item>
                      </Col>
                      <Col span={24}>
                        <Form.Item label="Dogs Allowed" name={"isDogsAllowed"}>
                          <Select
                            style={{
                              width: "100%",
                            }}
                            options={[
                              {
                                value: "Large",
                                label: "Large",
                              },
                              {
                                value: "Small",
                                label: "Small",
                              },
                              {
                                value: "None",
                                label: "None",
                              },
                            ]}
                            onChange={onchangValue}
                          />
                        </Form.Item>
                      </Col>
                    </Row>
                    <Form.Item label=" ">
                      <Button type="primary" htmlType="submit">
                        Search
                      </Button>
                    </Form.Item>
                  </Form>
                </FilterContainer>
              </Col>
            </Row>

            <Row justify="space-between">
              <Col>
                <Row>
                  <Col span={24}>
                    <h4>Vacancy Posting Contact Settings:</h4>
                  </Col>
                  <Col span={24}>
                    <span>{userInfo?.email}</span>
                  </Col>
                </Row>
              </Col>
              <Col className="sort-by">
                {/* <Row gutter={[8, 0]} align="middle">
              <Col>
                <span>Sort By:</span>
              </Col>
              <Col>
                <Select options={vacncssortby} />{" "}
              </Col>
            </Row> */}
              </Col>
            </Row>
            {vacanciesData?.map((property, index) => {
              return (
                <>
                  <Row gutter={[40, 0]} className="guest-card" key={index}>
                    <Col span={6}>
                      <Row>
                        <Col span={24}>
                          <img
                            src={
                              property?.attachments?.length > 0
                                ? property?.attachments[0]?.downloadURL
                                : propertyImage
                            }
                            alt="property"
                          />
                        </Col>
                        <Col span={24}>
                          <Row justify="center">
                            <Col>
                              <span>
                                {property?.attachments?.length > 0
                                  ? property?.attachments?.length
                                  : "0"}{" "}
                                {property?.attachments?.length > 1
                                  ? "Photos"
                                  : "Photo"}
                              </span>
                            </Col>
                          </Row>
                        </Col>
                      </Row>
                    </Col>
                    <Col span={10}>
                      <Row gutter={[0, 8]}>
                        <Col span={24}>
                          <a href={`/property-tabs/property/${property?.id}`}>
                            {property?.propertyNameAddress?.propertyName}
                          </a>
                        </Col>
                        <Col span={24}>
                          <span>
                            {`${property?.propertyNameAddress?.propertyName},
                          ${property?.propertyNameAddress?.addressLine1}
                          ${
                            property?.propertyNameAddress?.addressLine2
                              ? property?.propertyNameAddress?.addressLine2
                              : ""
                          }
                          `}
                          </span>
                        </Col>
                        <Col span={24}>
                          <Row gutter={[4, 0]}>
                            <Col span={4} className="border-right">
                              <span>BD/BA</span>
                            </Col>
                            <Col span={4} className="border-right">
                              <span>SQ.FT.</span>
                            </Col>
                            <Col span={4} className="border-right">
                              <span>RENT</span>
                            </Col>
                            <Col span={4} className="border-right">
                              <span>AVAILABLE</span>
                            </Col>
                          </Row>
                          <Row gutter={[4, 0]}>
                            <Col span={4} className="border-right">
                              <span className="span-text">
                                {property?.rentalInformation.bedrooms
                                  ? property?.rentalInformation.bedrooms
                                  : "--"}
                                /
                                {property?.rentalInformation.bathrooms
                                  ? property?.rentalInformation.bathrooms
                                  : "--"}
                              </span>
                            </Col>
                            <Col span={4} className="border-right">
                              <span className="span-text">
                                {property?.rentalInformation.squareFeet
                                  ? property?.rentalInformation.squareFeet
                                  : "--"}
                              </span>
                            </Col>
                            <Col span={4} className="border-right">
                              <span className="span-text">
                                ${" "}
                                {property?.rentalInformation.marketRent
                                  ? property?.rentalInformation.marketRent
                                  : "--"}
                              </span>
                            </Col>
                            <Col span={4} className="border-right">
                              <span className="span-text">
                                {property?.rentalInformation.rentReady
                                  ? "Yes"
                                  : "No"}
                              </span>
                            </Col>
                          </Row>
                        </Col>
                      </Row>
                    </Col>
                    <Col span={8}>
                      <Row justify="center" className="row-gap">
                        <Col
                          className={
                            property?.rented
                              ? "never-rented rented"
                              : "never-rented"
                          }
                          span={24}
                        >
                          <span>{property?.rentType}</span>
                        </Col>
                      </Row>
                      <Row justify="end" className="row-gap">
                        <Col>
                          <Dropdown
                            menu={{
                              items,
                              onClick,
                            }}
                            trigger={["click"]}
                            placement="bottomRight"
                            onClick={() => setId(property?.id)}
                          >
                            <a
                              href="nothing"
                              onClick={(e) => e.preventDefault()}
                              style={{ textDecoration: "none", color: "black" }}
                            >
                              <Space className="action-span">
                                <span>Actions</span>
                                <SlOptions />
                              </Space>
                            </a>
                          </Dropdown>
                        </Col>
                      </Row>
                      <Row>
                        <Col span={24}>
                          <Row
                            justify="space-between"
                            align="middle"
                            className="row-gap"
                          >
                            <Col>
                              <h4>Website</h4>
                            </Col>
                            <Col>
                              <span>Not Posted</span>
                            </Col>
                            <Col>
                              <Button
                                type="primary"
                                onClick={() =>
                                  setWebsiteConfirmationBoxOpen(true)
                                }
                              >
                                Post
                              </Button>
                            </Col>
                          </Row>
                        </Col>
                        <Col span={24}>
                          <Row
                            justify="space-between"
                            align="middle"
                            className="row-gap"
                          >
                            <Col>
                              <h4>Internet</h4>
                            </Col>
                            <Col>
                              <span>Not Posted</span>
                            </Col>
                            <Col>
                              <Button
                                type="primary"
                                onClick={() =>
                                  setInternetConfirmationBoxOpen(true)
                                }
                              >
                                Post
                              </Button>
                            </Col>
                          </Row>
                        </Col>
                        <Col span={24}>
                          <Row justify="space-between" align="middle">
                            <Col>
                              <h4>Premium</h4>
                            </Col>
                            <Col>
                              <span>Off</span>
                            </Col>
                            <Col>
                              <Button
                                type="primary"
                                onClick={() =>
                                  setPremiumConfirmationBoxOpen(true)
                                }
                              >
                                Activate
                              </Button>
                            </Col>
                          </Row>
                        </Col>
                      </Row>
                    </Col>
                  </Row>
                </>
              );
            })}
          </div>
          <div className="RightSidebar">
            <RightBar RightBarData={VacanciesRightBar} />
          </div>
          {websiteConfirmationBoxOpen ? (
            <ConfirmationBox
              setIsConfirmationBoxOpen={setWebsiteConfirmationBoxOpen}
            >
              <h2>Please Update Required Fields</h2>
              <div className="message-container">
                <BsInfoCircleFill size={18} />
                <span>
                  To ensure maximum reach, please update the following missing
                  information.
                </span>
              </div>
              <Row>
                <Col span={24}>
                  <Row>
                    <Col span={6} className="span-container header">
                      <span>Field Name</span>
                    </Col>
                    <Col span={18} className="span-container header">
                      <span>Link to Edit</span>
                    </Col>
                  </Row>
                </Col>
                <Col span={24}>
                  <Row>
                    <Col span={6} className="span-container data">
                      <span>Available On</span>
                    </Col>
                    <Col span={18} className="span-container data">
                      <span className="onclick-text">
                        Enter an available on date
                      </span>
                    </Col>
                  </Row>
                </Col>
              </Row>
              <div className="action-buttons">
                <button
                  className="blue"
                  onClick={() => setWebsiteConfirmationBoxOpen(false)}
                >
                  Save & Post
                </button>
                <button
                  className="cancel-btn"
                  onClick={() => setWebsiteConfirmationBoxOpen(false)}
                >
                  Post Anyway
                </button>
                <button
                  className="cancel-btn"
                  onClick={() => setWebsiteConfirmationBoxOpen(false)}
                >
                  Cancel
                </button>
              </div>
            </ConfirmationBox>
          ) : null}
          {internetConfirmationBoxOpen ? (
            <ConfirmationBox
              setIsConfirmationBoxOpen={setInternetConfirmationBoxOpen}
            >
              <h2>Please Update Required Fields</h2>
              <div className="message-container">
                <BsInfoCircleFill size={18} />
                <span>
                  To ensure maximum reach, please update the following missing
                  information.
                </span>
              </div>
              <Row>
                <Col span={24}>
                  <Row>
                    <Col span={6} className="span-container header">
                      <span>Field Name</span>
                    </Col>
                    <Col span={18} className="span-container header">
                      <span>Link to Edit</span>
                    </Col>
                  </Row>
                </Col>
                <Col span={24}>
                  <Row>
                    <Col span={6} className="span-container data">
                      <span>Available On</span>
                    </Col>
                    <Col span={18} className="span-container data">
                      <span className="onclick-text">
                        Enter an available on date
                      </span>
                    </Col>
                  </Row>
                  <Row>
                    <Col span={6} className="span-container data">
                      <span>Photo</span>
                    </Col>
                    <Col span={18} className="span-container data">
                      <span className="onclick-text">
                        Upload a valid photo for the unit
                      </span>
                    </Col>
                  </Row>
                  <Row>
                    <Col span={6} className="span-container data">
                      <span>State</span>
                    </Col>
                    <Col span={18} className="span-container data">
                      <span className="onclick-text">
                        Enter a valid US state (e.g. CA)
                      </span>
                    </Col>
                  </Row>
                </Col>
              </Row>
              <Form
                labelCol={8}
                wrapperCol={11}
                colon={false}
                className="form-container"
              >
                <Form.Item label="Marketing Title">
                  <Input />
                </Form.Item>
                <Form.Item label="Marketing Description">
                  <TextArea></TextArea>
                </Form.Item>
              </Form>
              <div className="action-buttons">
                <button
                  className="blue"
                  onClick={() => setInternetConfirmationBoxOpen(false)}
                >
                  Save & Post
                </button>
                <button
                  className="cancel-btn"
                  onClick={() => setInternetConfirmationBoxOpen(false)}
                >
                  Post Anyway
                </button>
                <button
                  className="cancel-btn"
                  onClick={() => setInternetConfirmationBoxOpen(false)}
                >
                  Cancel
                </button>
              </div>
            </ConfirmationBox>
          ) : null}
          {premiumConfirmationBoxOpen ? (
            <ConfirmationBox
              setIsConfirmationBoxOpen={setPremiumConfirmationBoxOpen}
            >
              <h2>Activate Property for Premium Leads</h2>
              <p className="message">
                Advertise this property on premium listing sites and get
                featured placements on free sites.{" "}
                <span className="onclick-text">Learn more.</span>
              </p>
              <p className="message">
                <strong>Property: </strong> test 2
              </p>
              <p className="message">
                <strong>Price: </strong> $10.00 per verified lead, billed
                monthly
              </p>

              <Form layout="vertical" colon={false} className="form-container">
                <Form.Item label="Monthly Cap" required>
                  <Space>
                    <InputNumber
                      addonBefore={<FaDollarSign size={12} />}
                      defaultValue="250.00"
                    />
                  </Space>
                  <p className="plain-text">max leads per month: 25</p>
                </Form.Item>
                <Form.Item>
                  <Checkbox checked={checked} onChange={onChange}>
                    I agree to activate this property for Premium Leads {`(`}
                    <span className="onclick-text">terms</span>
                    {`)`}
                  </Checkbox>
                </Form.Item>
              </Form>

              <div className="action-buttons">
                <Button
                  type="primary"
                  onClick={() => setPremiumConfirmationBoxOpen(false)}
                  disabled={disabled}
                  className={disabled ? "disable-btn" : null}
                >
                  Activate Premium Leads
                </Button>
                <button
                  className="cancel-btn"
                  onClick={() => setPremiumConfirmationBoxOpen(false)}
                >
                  Cancel
                </button>
              </div>
            </ConfirmationBox>
          ) : null}
        </>
      )}
    </>
  );
}

export default Vacancies;
